const INSIGHTS_ENDPOINT = {
  LIST: '/insights',
  FILTERS: '/insights/filters'
};

export default INSIGHTS_ENDPOINT;
